
export const translations = {
  en: {
    heroTitle: "Your AI Social Media Manager",
    heroSubtitle: "PlataPost helps you plan, write, organize, and manage your social media content using advanced AI, tailored to your brand voice.",
    startFree: "Go Solo",
    seeHowItWorks: "See How It Works",
    nextGenStrategy: "Next-Gen Content Strategy",
    planSmarter: "Plan Smarter, Post Faster",
    everythingNeeded: "Everything you need to dominate social media with AI.",
    aiPostGen: "AI Post Generation",
    aiPostGenDesc: "Generate high-quality captions and visual concepts for Instagram, LinkedIn, TikTok, and more.",
    smartCalendar: "Smart Content Calendar",
    smartCalendarDesc: "A beautiful, intuitive calendar to drag and drop your ideas and view your entire month's strategy.",
    brandVoice: "Brand Voice Mastery",
    brandVoiceDesc: "Train the AI on your specific brand identity to ensure consistent tone across every single post.",
    postsGenerated: "Posts Generated",
    activeBrands: "Active Brands",
    voiceAccuracy: "Voice Accuracy",
    aiConsistency: "AI Consistency",
    readyToAutomate: "Ready to automate your social hustle?",
    joinHundreds: "Join hundreds of owners and managers who have reclaimed their time with PlataPost.",
    goToDashboard: "Go to Dashboard",
    login: "Login",
    pricing: "Pricing",
    features: "Features",
    howItWorks: "How It Works",
    blog: "Blog",
    portfolio: "Portfolio",
    search: "Search...",
    startFreeTrial: "Start Free Trial",
    brands: "Brands",
    user: "User",
    users: "Users",
    saveChanges: "Save Changes",
    success: "Success!",
    error: "Error!",
    msgSaved: "Changes saved successfully.",
    msgPostGenerated: "Post generated successfully!",
    msgInspirationAnalyzed: "Inspiration analyzed!",
    msgWebsiteSynced: "Website context synced!",
    billingMonthly: "Monthly",
    billingYearly: "Yearly",
    save20: "Save 20%",
    language: "Language",
    dashboard: "Dashboard",
    brandProfile: "Brand Profile",
    contentPlans: "Content Plans",
    calendarBookings: "Calendar Bookings",
    insights: "Insights",
    socialInbox: "Social Inbox",
    settings: "Settings",
    adminStats: "Admin Stats",
    adminContent: "Admin Content",
    manageBlog: "Manage Blog",
    manageShowcase: "Manage Showcase",
    navigation: "Navigation",
    newBrand: "New Brand",
    targetMonth: "Target Month",
    year: "Year",
    keyProducts: "Key Products/Services for this Plan",
    keyProductsDesc: "What specific products or services should we focus on this month?",
    specificGoals: "Specific Goals for this Plan",
    specificGoalsDesc: "What are the primary objectives for this content calendar?",
    generateMonthlyCalendar: "Generate Monthly Calendar",
    generating: "Generating...",
    approve: "Approve",
    reject: "Reject",
    quickFix: "Quick Fix",
    regenImage: "Regen Image",
    regenImageDesc: "Generate a high-quality image based on this post's concept.",
    regenVideo: "Regen Video",
    regenVideoDesc: "Generate a cinematic video based on this post's concept.",
    upload: "Upload",
    save: "Save",
    bestTimeToPost: "Best time to post",
    preview: "Preview",
    genImage: "Gen Image",
    genVideo: "Gen Video",
    suggestEdit: "Suggest Edit",
    approveEntirePlan: "Approve Entire Plan",
    revertToDraft: "Revert to Draft",
    selected: "Selected",
    posts: "Posts",
    delete: "Delete",
    confirmDelete: "Confirm Delete?",
    cancel: "Cancel",
    monthlyHighlights: "Monthly Highlights (Events, Promotions, Projects)",
    months: {
      January: "January",
      February: "February",
      March: "March",
      April: "April",
      May: "May",
      June: "June",
      July: "July",
      August: "August",
      September: "September",
      October: "October",
      November: "November",
      December: "December"
    },
    welcomeBack: "Welcome back",
    highlightPlaceholder: "Highlight",
    viewingWorkspace: "Viewing Workspace",
    observingStrategy: "You are currently observing this user's social strategy and content plans.",
    happeningStrategy: "Here's what's happening with your social strategy.",
    completeBrandProfile: "Complete your Brand Profile",
    toGenerateContent: "To generate content, we first need to understand your brand's voice, audience, and goals.",
    getStarted: "Get Demo",
    activePlans: "Active Plans",
    approvedPosts: "Approved Posts",
    pendingReview: "Pending Review",
    unlimited: "Unlimited",
    left: "Left",
    upgrade: "Upgrade",
    topUp: "Top Up",
    createMonthlyPlan: "Create Monthly Plan",
    viewerAccess: "Viewer Access",
    readOnlyAccess: "You have read-only access to this brand profile and its content plans.",
    manageReviewPlans: "Manage and review your generated content calendars.",
    noPlansYet: "No plans generated yet. Head to the dashboard to create one.",
    stopImpersonation: "Stop Impersonation",
    aiTokens: "AI Tokens",
    logout: "Logout",
    workspace: "Workspace",
    activeBrand: "Active Brand",
    landingTitle: "The Intelligent Command Center for Your Social Presence.",
    landingSubtitle: "PlataPost dynamically generates, schedules, and distributes context-aware social content, grounded in your brand identity and documents.",
    platform: "Platform",
    resources: "Resources",
    company: "Company",
    bookDemo: "Start Free Trial",
    documentation: "Documentation",
    privacyPolicy: "Privacy Policy",
    termsOfService: "Terms of Service",
    contactUs: "Contact Us",
    rightsReserved: "All rights reserved.",
    poweredByContext: "Powered by Context",
    contextDesc: "Your brand's knowledge base and writing style.",
    docUpload: "Doc Upload",
    voiceTone: "Voice & Tone",
    seamlessDistribution: "Seamless Distribution",
    distributionDesc: "Auto-publish to all platforms.",
    insightsStrategies: "Insights & Strategies",
    blogSubtitle: "Master the art of AI-powered social media growth.",
    noPosts: "No blog posts yet.",
    writeFirst: "Write the first one",
    readMore: "Read More",
    addCustomPost: "Add Custom Post",
    postTopic: "What should this post be about?",
    postTopicPlaceholder: "e.g., A post about our new summer collection launch with a 20% discount code.",
    date: "Date",
    format: "Format (Optional)",
    aiSelectsBest: "AI Selects Best",
    singleFeedPost: "Single Feed Post",
    singleStoryPost: "Single Story Post",
    carousel: "Carousel",
    generateAddPost: "Generate & Add Post",
    unnamedBrand: "Unnamed Brand",
    brandLimitReached: "Brand limit reached",
    upgradeBrandMsg: "Please upgrade your existing brand to create more.",
    freeTrial: "Free Trial",
    solo: "Solo",
    growth: "Growth",
    agency: "Agency",
    enterprise: "Enterprise",
    custom: "Custom",
    upgradeTo: "Upgrade to",
    billedAnnually: "Billed annually",
    mostPopular: "Most Popular",
    featuresTitle: "The Intelligent Command Center for your Social Presence.",
    featuresSubtitle: "PlataPost dynamically generates, schedules and distributes context-aware social content, founded on your brand's identity and documents.",
    faqTitle: "Frequently Asked Questions",
    faqSubtitle: "Everything you need to know about getting the most out of PlataPost.",
    faqWhatIsPlataPost: "What is PlataPost?",
    faqWhatIsPlataPostAns: "PlataPost is an all-in-one AI platform designed to help you manage social media content from idea to distribution.",
    faqWhoIsPlataPostFor: "Who is PlataPost for?",
    faqWhoIsPlataPostForAns: "It's built for individual creators, small business owners, marketing agencies, and anyone who needs to maintain a consistent social presence without spending hours every day on it.",
    faqIsPlataPostGoodForAgencies: "Is PlataPost good for agencies?",
    faqIsPlataPostGoodForAgenciesAns: "Yes! Our Agency plan allows for multiple brand profiles, making it easy to manage several distinct clients with unique voices and strategies.",
    faqCanPlataPostWritePosts: "Can PlataPost write social media posts?",
    faqCanPlataPostWritePostsAns: "Absolutely. Our AI can generate full captions, hooks, and hashtags for Instagram, LinkedIn, TikTok, Facebook, and Twitter.",
    faqBrandVoice: "Can I use my own brand voice?",
    faqBrandVoiceAns: "Yes! Our platform specializes in learning your brand voice and maintaining it across all generated content.",
    faqCanIEditContent: "Can I edit the generated content?",
    faqCanIEditContentAns: "Yes, you have full control. You can edit any part of the generated copy, refine it with specific AI instructions (like 'Make it more funny'), or manually tweak the results.",
    faqHowMuchDoesItCost: "How much does PlataPost cost?",
    faqHowMuchDoesItCostAns: "We offer several tiers starting from R150/month for solopreneurs up to enterprise levels for large agencies. Check our Pricing page for full details.",
    faqDoesPlataPostSchedule: "Does PlataPost schedule posts?",
    faqDoesPlataPostScheduleAns: "We offer smart scheduling and direct publishing for supported platforms. For others, we provide a clean export workflow to get your content live manually.",
    faqPlatforms: "Which platforms are supported?",
    faqPlatformsAns: "We support Instagram, LinkedIn, TikTok, Facebook, and Twitter/X.",
    viewAllFaqs: "View all FAQs",
    useCases: "Use Cases",
    smallBusinesses: "Small Businesses",
    agencies: "Agencies",
    creators: "Creators",
    marketingTeams: "Marketing Teams",
    about: "About",
    contact: "Contact",
    pricingPlans: "Plans & Pricing",
    featuresTools: "Features & Capabilities",
    seoHomeTitle: "Your AI Social Media Manager",
    seoHomeDesc: "All-in-one AI platform for managing social media content.",
    contactSales: "Contact Sales",
    southAfrica: "South Africa",
    unitedStates: "United States",
    unitedKingdom: "United Kingdom",
    brazil: "Brazil",
    appliedPromo: "*PROMO APPLIED (FIRST MONTH)",
    goGrowth: "Go Growth",
    plTrialFeatures: [
      "1 Brand Profile",
      "20 Free AI Tokens",
      "1 Active Plan",
      "No Credit Card Required"
    ],
    plSoloFeatures: [
      "1 Brand Profile",
      "3 Active Plans",
      "30 AI Generations / mo",
      "Standard AI Models",
      "Email Support"
    ],
    plGrowthFeatures: [
      "3 Brand Profiles",
      "10 Active Plans",
      "Unlimited AI Generations",
      "Advanced AI Models (Pro)",
      "Priority Support",
      "Team Collaboration"
    ],
    plAgencyFeatures: [
      "10 Brand Profiles",
      "30 Active Plans",
      "Unlimited Generations",
      "Enterprise AI Models",
      "Dedicated Account Manager",
      "Custom Brand Voice Analysis"
    ],
    contactConnect: "Connect",
    contactLetsConnect: "Let's Connect.",
    contactHeroSubtitle: "Whether you're a creator looking to scale or an agency manager needing better tools, we're here to help.",
    emailUs: "Email Us",
    generalInquiries: "General inquiries and support",
    followUs: "Follow Us",
    getUpdates: "Get updates and AI tips",
    messageSent: "Message Sent!",
    thanksForReaching: "Thanks for reaching out. Our team will get back to you within 24 hours.",
    sendAnother: "Send another message",
    fullName: "Full Name",
    emailAddress: "Email Address",
    subject: "Subject",
    message: "Message",
    sendMessage: "Send Message",
    sending: "Sending...",
    tellUsHelp: "Tell us what you need help with...",
    manageBilling: "Manage Billing & Cancel",
    promoCode: "Promo Code",
    freeTrialFeature: "1 Brand, 1 Trial Plan, 20 AI Tokens, 1 User",
    soloPostsFeature: "1 Brand, 3 Active Plans, 60 Tokens, 1 User",
    growthPostsFeature: "3 Brands, 10 Plans, 200 Tokens, 5 Users",
    agencyPostsFeature: "10 Brands, 30 Plans, 500 Tokens, 20 Users",
    ogLocale: "en_US",
    aiVideoBadge: "New: AI Video Generation now available",
    trustedBy: "TRUSTED BY INNOVATIVE BRANDS",
    builtForFounders: "Built for modern founders",
    commandCenterTitle: "The Intelligent Command Center for your Social Presence.",
    commandCenterDesc: "PlataPost dynamically generates, schedules, and distributes context-aware content across every platform—powered by your brand identity, documents, and goals.",
    powerfulFeaturesKey: "Powerful Features",
    aiStrategy: "AI Strategy",
    aiStrategyDesc: "Smart content strategies tailored to your brand goals and audience insights.",
    instantGeneration: "Instant Generation",
    instantGenerationDesc: "Generate captions, posts, and ideas in seconds with advanced AI.",
    brandVoiceFeature: "Brand Voice",
    brandVoiceFeatureDesc: "Consistent tone and messaging powered by your Brand Brain and assets.",
    step1Title: "Upload Your Brand Docs",
    step1Desc: "Upload PDFs, docs, links, and assets to build your knowledge base.",
    step2Title: "Train Your Brand Brain",
    step2Desc: "Our AI learns your brand voice, products, services, and audience.",
    step3Title: "Generate Weekly Content",
    step3Desc: "Get a curated set of posts, captions, and visuals tailored to your goals.",
    step4Title: "Schedule & Publish",
    step4Desc: "Review, schedule, and publish across all your social platforms with ease.",
    faqCharacterTitle: "Everything else you need to know.",
    ctaTitle: "Ready to scale your brand?",
    ctaSubtitle: "Let PlataPost handle your content so you can focus on what you do best. Join hundreds of growing brands today.",
    heroSlogan1: "YOU BUILT THE",
    heroSlogan2: "BUSINESS.",
    heroSlogan3: "WE BUILD THE",
    heroSlogan4: "CONTENT.",
    selectRegion: "Select your Region",
    perMonth: "/mo",
    simplePricing: "Simple Pricing",
    pricingSubtitle: "Focus on creating value, not on counting costs. Start for free and upgrade as you grow.",
    promoCodeLabel: "Have a promo code?",
    trialDesc: "Test PlataPost risk-free to build your strategy.",
    soloDesc: "Perfect for personal brands and solopreneurs.",
    growthDesc: "Ideal for small businesses and growing teams.",
    agencyDesc: "Built for agencies managing multiple clients.",
    featuredIn: "Featured in",
    month: "month",
    howItWorksProcess: "The Process",
    monthShort: "mo",
    yearShort: "yr",
    howItWorksSubtitle: "From brand strategy to ready-to-publish content in four simple steps.",
    whatBehind: "What happens behind the scenes:",
    examplesTitle: "Example prompts:",
    readyToTurn: "Ready to turn your brand strategy into a full content calendar?",
    startWithBrain: "Start with your Brand Brain and let PlataPost build the plan.",
    strategyCopyCreative: "Strategy, Copy & Creative Together",
    strategyCopyCreativeDesc: "PlataPost connects strategy, captions, visual direction, and content scheduling in one workflow, so your posts feel consistent across every platform.",
    stayInControl: "You Stay in Control",
    stayInControlDesc: "The AI handles the heavy lifting, but you make the final call. Review, refine, approve, schedule, or export whenever you’re ready.",
    stepLabel: "Step",
    proprietaryAILogic: "Proprietary AI Logic",
    whyDifferent: "Why PlataPost is Different",
    noGenericAI: "No Generic AI",
    noGenericAIDesc: "PlataPost does not rely on one-size-fits-all prompts. Every content plan and post is grounded in your brand details, documents, goals, and audience.",
    multimodalStrategy: "Multimodal Strategy",
    multimodalStrategyDesc: "Our AI handles text, visual concepts, and video direction simultaneously for perfect coherence.",
    humanCentered: "Human Centered",
    humanCenteredDesc: "You maintain full creative control. The AI is your high-speed assistant, not a replacement.",
    getStartedNow: "Get Demo",
    plataPostFeatures: "PlataPost Features",
    builtForModernGrowth: "Built for Modern Growth.",
    featuresHeroSubtitle2: "Social media is a full-time job. We turned it into a single button.",
    aiCaptionWriting: "AI Caption Writing",
    aiCaptionWritingDesc: "Stop staring at a blank screen. Generate clever, engaging captions, hooks, and calls-to-action that actually convert.",
    smartScheduling: "Smart Scheduling",
    smartSchedulingDesc: "Queue your content for the optimal time. Currently supports manual export and direct publishing for specific platforms.",
    endlessContentIdeas: "Endless Content Ideas",
    endlessContentIdeasDesc: "Stuck on what to post? Get a full month of strategy-backed content ideas based on your business goals and products.",
    oneIdeaManyPlatforms: "One Idea, Many Platforms",
    repurposeEffortlessly: "Repurpose your content effortlessly.",
    repurposeEffortlesslyDesc: "Found a great blog post or internal strat doc? Feed it to PlataPost and get a week's worth of LinkedIn posts, Instagram carousels, and TikTok scripts in seconds.",
    featureList: [
      "Direct API Publishing",
      "Context-Aware AI",
      "Visual Concept Generation"
    ],
    startBuildingCalendar: "Start building your calendar",
    canIChangePlans: "Can I change plans later?",
    canIChangePlansAns: "Absolutely. You can upgrade or downgrade your plan at any time through your dashboard settings.",
    isThereAFreeTrialPricing: "Is there a free trial?",
    isThereAFreeTrialPricingAns: "You get 20 free AI tokens when you sign up to try generating plans, images, and content. You can continue using the platform securely with one active monthly plan, but will need to top up tokens or upgrade for further AI use.",
    viewAllQuestions: "View all FAQs",
    faqHeroSubtitle: "Everything you need to know about getting the most out of PlataPost.",
    stillHaveQuestions: "Still have questions?",
    stillHaveQuestionsDesc: "Our team is here to help you automate your social media strategy. Reach out and we'll get back to you shortly.",
    contactSupport: "Contact Support",
    catGeneral: "General",
    catHowItWorks: "How It Works",
    catPricingSupport: "Pricing & Support",
    aboutHeroTitle: "Our Mission.",
    aboutHeroSubtitle: "Social media should be about building connections, not battling burnout.",
    aboutSectionTitle: "Consistency is the hardest part.",
    aboutSectionP1: "We started PlataPost because we saw too many incredible creators and small business owners struggling to keep their social feeds active while actually running their businesses.",
    aboutSectionP2: "The problem isn't a lack of ideas—it's the friction of turning those ideas into polished posts, day after day, across five different platforms that all want something different.",
    aboutSectionP3: "PlataPost eliminates that friction. Our AI doesn't just 'write' for you; it acts as a strategic partner that understands your brand voice, handles the tedious formatting, and lets you focus on what you're best at.",
    aboutValue1: "Empowerment",
    aboutValue2: "Authenticity",
    aboutValue3: "Efficiency",
    aboutBuiltWithPassion: "Built with passion for digital growth.",
    aboutNeedToReachUs: "Need to reach us? We'd love to hear from you.",
    steps: {
      step1: {
        title: "Build Your Brand Brain",
        desc: "Tell PlataPost about your business, audience, goals, and preferred tone of voice. Upload brand assets, strategy documents, product information, or past content so the AI can understand what makes your brand unique.",
        behind: "PlataPost turns your inputs into a living brand knowledge base that guides every content recommendation.",
      },
      step2: {
        title: "Generate Your Content Calendar",
        desc: "Choose your month, platforms, and campaign goals. PlataPost creates a complete content strategy with platform-specific post ideas, topics, themes, and highlights for each week.",
        behind: "Your Brand Brain maps your goals into a structured content plan designed for consistency, relevance, and momentum.",
      },
      step3: {
        title: "Review & Refine",
        desc: "Review the AI-generated posts before anything goes live. Want a different tone, shorter copy, stronger hook, or another language? Just ask PlataPost to refine it.",
        behind: "PlataPost updates the content while staying aligned with your brand voice, audience, and campaign goals.",
        examples: ["“Make it punchier.”", "“Translate to Portuguese.”", "“Make this sound more professional.”"]
      },
      step4: {
        title: "Schedule or Export",
        desc: "Once you’re happy with the content, schedule posts to publish automatically or export the copy and creative assets for manual posting.",
        behind: "PlataPost packages your approved content into a clear publishing workflow, whether you want full automation or hands-on control.",
      }
    }
  },
  br: {
    heroTitle: "Seu Gestor de Redes Sociais com IA",
    heroSubtitle: "A PlataPost ajuda você a planejar, escrever, organizar e gerenciar seu conteúdo para redes sociais usando IA avançada, adaptada à voz da sua marca.",
    startFree: "Mudar para Solo",
    seeHowItWorks: "Veja Como Funciona",
    nextGenStrategy: "Estratégia de Conteúdo de Próxima Geração",
    planSmarter: "Planeje Melhor, Poste Mais Rápido",
    everythingNeeded: "Tudo o que você precisa para dominar as redes sociais com IA.",
    aiPostGen: "Geração de Posts com IA",
    aiPostGenDesc: "Gere legendas de alta qualidade e conceitos visuais para Instagram, LinkedIn, TikTok e mais.",
    smartCalendar: "Calendário de Conteúdo Inteligente",
    smartCalendarDesc: "Um calendário bonito e intuitivo para arrastar suas ideias e visualizar toda a sua estratégia do mês.",
    brandVoice: "Domínio da Voz da Marca",
    brandVoiceDesc: "Treine a IA na identidade específica da sua marca para garantir um tom consistente em cada postagem.",
    postsGenerated: "Posts Gerados",
    activeBrands: "Marcas Ativas",
    voiceAccuracy: "Precisão da Voz",
    aiConsistency: "Consistência da IA",
    readyToAutomate: "Pronto para automatizar sua rotina social?",
    joinHundreds: "Junte-se a centenas de proprietários e gestores que recuperaram seu tempo com o PlataPost.",
    goToDashboard: "Ir para o Painel",
    login: "Entrar",
    pricing: "Preços",
    features: "Recursos",
    howItWorks: "Como Funciona",
    blog: "Blog",
    portfolio: "Portfólio",
    search: "Pesquisar...",
    startFreeTrial: "Iniciar Teste Grátis",
    brands: "Marcas",
    user: "Usuário",
    users: "Usuários",
    saveChanges: "Salvar Alterações",
    success: "Sucesso!",
    error: "Erro!",
    msgSaved: "Alterações salvas com sucesso.",
    msgPostGenerated: "Post gerado com sucesso!",
    msgInspirationAnalyzed: "Inspiração analisada!",
    msgWebsiteSynced: "Contexto do site sincronizado!",
    billingMonthly: "Mensal",
    billingYearly: "Anual",
    save20: "Economize 20%",
    language: "Idioma",
    dashboard: "Dashboard",
    brandProfile: "Perfil da Marca",
    contentPlans: "Planos de Conteúdo",
    calendarBookings: "Agendamentos",
    insights: "Relatórios",
    socialInbox: "Caixa de Entrada",
    settings: "Configurações",
    adminStats: "Estatísticas Admin",
    adminContent: "Conteúdo Admin",
    manageBlog: "Gerenciar Blog",
    manageShowcase: "Gerenciar Portfólio",
    navigation: "Navegação",
    newBrand: "Nova Marca",
    targetMonth: "Mês Alvo",
    year: "Ano",
    keyProducts: "Principais Produtos/Serviços para este Plano",
    keyProductsDesc: "Em quais produtos ou serviços específicos devemos focar este mês?",
    specificGoals: "Objetivos Específicos para este Plano",
    specificGoalsDesc: "Quais são os principais objetivos para este calendário de conteúdo?",
    generateMonthlyCalendar: "Gerar Calendário Mensal",
    generating: "Gerando...",
    approve: "Aprovar",
    reject: "Rejeitar",
    quickFix: "Ajuste Rápido",
    regenImage: "Gerar Foto",
    regenImageDesc: "Gere uma imagem de alta qualidade baseada no conceito deste post.",
    regenVideo: "Gerar Vídeo",
    regenVideoDesc: "Gere um vídeo cinematográfico baseado no conceito deste post.",
    upload: "Upload",
    save: "Salvar",
    bestTimeToPost: "Melhor horário para postar",
    preview: "Visualizar",
    genImage: "Gerar Foto",
    genVideo: "Gerar Vídeo",
    suggestEdit: "Sugerir Edição",
    approveEntirePlan: "Aprovar Todo o Plano",
    revertToDraft: "Voltar para Rascunho",
    selected: "Selecionados",
    posts: "Posts",
    delete: "Excluir",
    confirmDelete: "Confirmar Exclusão?",
    cancel: "Cancelar",
    monthlyHighlights: "Destaques Mensais (Eventos, Promoções, Projetos)",
    months: {
      January: "Janeiro",
      February: "Fevereiro",
      March: "Março",
      April: "Abril",
      May: "Maio",
      June: "Junho",
      July: "Julho",
      August: "Agosto",
      September: "Setembro",
      October: "Outubro",
      November: "Novembro",
      December: "Dezembro"
    },
    welcomeBack: "Bem-vindo de volta",
    highlightPlaceholder: "Destaque",
    viewingWorkspace: "Visualizando Workspace",
    observingStrategy: "Você está observando a estratégia social e planos de conteúdo deste usuário.",
    happeningStrategy: "Aqui está o que está acontecendo com sua estratégia social.",
    completeBrandProfile: "Complete o Perfil da sua Marca",
    toGenerateContent: "Para gerar conteúdo, primeiro precisamos entender a voz, o público e os objetivos da sua marca.",
    getStarted: "Agendar Demo",
    activePlans: "Planos Ativos",
    approvedPosts: "Posts Aprovados",
    pendingReview: "Pendentes",
    unlimited: "Ilimitado",
    left: "Restante",
    upgrade: "Fazer Upgrade",
    topUp: "Recarregar",
    createMonthlyPlan: "Criar Plano Mensal",
    viewerAccess: "Acesso de Observador",
    readOnlyAccess: "Você tem acesso apenas para leitura a este perfil de marca e seus planos de conteúdo.",
    manageReviewPlans: "Gerencie e revise seus calendários de conteúdo gerados.",
    noPlansYet: "Nenhum plano gerado ainda. Vá ao painel para criar um.",
    stopImpersonation: "Parar Personificação",
    aiTokens: "Créditos de IA",
    logout: "Sair",
    workspace: "Área de Trabalho",
    activeBrand: "Marca Ativa",
    landingTitle: "O Centro de Comando Inteligente para sua Presença Social.",
    landingSubtitle: "A PlataPost gera, agenda e distribui dinamicamente conteúdo social consciente do contexto, baseado na identidade e documentos da sua marca.",
    platform: "Plataforma",
    resources: "Recursos",
    company: "Empresa",
    bookDemo: "Iniciar Teste Grátis",
    documentation: "Documentação",
    privacyPolicy: "Política de Privacidade",
    termsOfService: "Termos de Serviço",
    contactUs: "Entre em Contato",
    rightsReserved: "Todos os direitos reservados.",
    poweredByContext: "Movido por Contexto",
    contextDesc: "A base de conhecimento e o estilo de escrita da sua marca.",
    docUpload: "Upload de Docs",
    voiceTone: "Voz e Tom",
    seamlessDistribution: "Distribuição Sem Costuras",
    distributionDesc: "Auto-publicação em todas as plataformas.",
    insightsStrategies: "Insights e Estratégias",
    blogSubtitle: "Domine a arte do crescimento nas redes sociais com IA.",
    noPosts: "Ainda não há posts no blog.",
    writeFirst: "Escreva o primeiro",
    readMore: "Ler Mais",
    addCustomPost: "Adicionar Post Personalizado",
    postTopic: "Sobre o que deve ser este post?",
    postTopicPlaceholder: "ex: Um post sobre o lançamento da nossa nova coleção de verão com um cupom de 20% de desconto.",
    date: "Data",
    format: "Formato (Opcional)",
    aiSelectsBest: "IA Seleciona o Melhor",
    singleFeedPost: "Post Único no Feed",
    singleStoryPost: "Post Único nos Stories",
    carousel: "Carrossel",
    generateAddPost: "Gerar e Adicionar Post",
    unnamedBrand: "Marca Sem Nome",
    brandLimitReached: "Limite de marcas atingido",
    upgradeBrandMsg: "Por favor, faça upgrade da sua marca existente para criar mais.",
    freeTrial: "Teste Grátis",
    solo: "Solo",
    growth: "Growth",
    agency: "Agência",
    enterprise: "Enterprise",
    custom: "Customizado",
    upgradeTo: "Mudar para",
    billedAnnually: "Cobrado anualmente",
    mostPopular: "Mais Popular",
    featuresTitle: "O Centro de Comando Inteligente para sua Presença Social.",
    featuresSubtitle: "A PlataPost gera, agenda e distribui dinamicamente conteúdo social consciente do contexto, baseado na identidade e documentos da sua marca.",
    faqTitle: "Perguntas Frequentes",
    faqSubtitle: "Tudo o que você precisa saber para aproveitar ao máximo o PlataPost.",
    faqWhatIsPlataPost: "O que é o PlataPost?",
    faqWhatIsPlataPostAns: "O PlataPost é uma plataforma de IA tudo-em-um projetada para ajudar você a gerenciar conteúdo de redes sociais, da ideia à distribuição.",
    faqWhoIsPlataPostFor: "Para quem é o PlataPost?",
    faqWhoIsPlataPostForAns: "Ele foi construído para criadores individuais, pequenos empresários, agências de marketing e qualquer um que precise manter uma presença social consistente.",
    faqIsPlataPostGoodForAgencies: "O PlataPost é bom para agências?",
    faqIsPlataPostGoodForAgenciesAns: "Sim! Nosso plano Agency permite múltiplos perfis de marca, facilitando o gerenciamento de vários clientes distintos.",
    faqCanPlataPostWritePosts: "O PlataPost pode escrever posts para redes sociais?",
    faqCanPlataPostWritePostsAns: "Com certeza. Nossa IA pode gerar legendas completas, ganchos e hashtags para Instagram, LinkedIn, TikTok, Facebook e Twitter.",
    faqBrandVoice: "Posso usar a voz da minha marca?",
    faqBrandVoiceAns: "Sim! Nossa plataforma é especializada em aprender a voz da sua marca e mantê-la em todo o conteúdo gerado.",
    faqCanIEditContent: "Posso editar o conteúdo gerado?",
    faqCanIEditContentAns: "Sim, você tem controle total. Você pode editar qualquer parte da cópia gerada ou usar instruções da IA para refinar o resultado.",
    faqHowMuchDoesItCost: "Quanto custa o PlataPost?",
    faqHowMuchDoesItCostAns: "Oferecemos vários níveis, começando em R$250/mês para solopreneurs. Confira nossa página de Preços para mais detalhes.",
    faqDoesPlataPostSchedule: "O PlataPost agenda as postagens?",
    faqDoesPlataPostScheduleAns: "Oferecemos agendamento inteligente e publicação direta para plataformas suportadas.",
    faqPlatforms: "Quais plataformas são suportadas?",
    faqPlatformsAns: "Oferecemos suporte para Instagram, LinkedIn, TikTok, Facebook e Twitter/X.",
    viewAllFaqs: "Ver todas as perguntas",
    useCases: "Casos de Uso",
    smallBusinesses: "Pequenas Empresas",
    agencies: "Agências",
    creators: "Criadores",
    marketingTeams: "Equipes de Marketing",
    about: "Sobre",
    contact: "Contato",
    pricingPlans: "Planos e Preços",
    featuresTools: "Recursos e Ferramentas",
    seoHomeTitle: "Seu Gestor de Redes Sociais com IA",
    seoHomeDesc: "Plataforma de IA tudo-em-um para gerenciar conteúdo de redes sociais.",
    contactSales: "Contatar Vendas",
    southAfrica: "África do Sul",
    unitedStates: "Estados Unidos",
    unitedKingdom: "Reino Unido",
    brazil: "Brasil",
    appliedPromo: "*PROMOÇÃO APLICADA (PRIMEIRO MÊS)",
    goGrowth: "Mudar para Growth",
    plTrialFeatures: [
      "1 Perfil de Marca",
      "20 Tokens de Inteligência Artificial Grátis",
      "1 Plano Ativo",
      "Sem Cartão de Crédito"
    ],
    plSoloFeatures: [
      "1 Perfil de Marca",
      "3 Planos Ativos",
      "30 Gerações de IA / mês",
      "Modelos de IA Padrão",
      "Suporte por E-mail"
    ],
    plGrowthFeatures: [
      "3 Perfis de Marca",
      "10 Planos Ativos",
      "Gerações de IA Ilimitadas",
      "Modelos de IA Avançados (Pro)",
      "Suporte Prioritário",
      "Calendário Colaborativo"
    ],
    plAgencyFeatures: [
      "10 Perfis de Marca",
      "30 Planos Ativos",
      "Tudo no plano Growth",
      "Status de Marca Branca (Em breve)",
      "Suporte Dedicado",
      "Acesso antecipado a recursos"
    ],
    contactConnect: "Conectar",
    contactLetsConnect: "Vamos nos Conectar.",
    contactHeroSubtitle: "Se você é um criador querendo escalar ou um gestor de agência precisando de ferramentas melhores, estamos aqui para ajudar.",
    emailUs: "Envie um E-mail",
    generalInquiries: "Dúvidas gerais e suporte",
    followUs: "Siga-nos",
    getUpdates: "Receba atualizações e dicas de IA",
    messageSent: "Mensagem Enviada!",
    thanksForReaching: "Obrigado por entrar em contato. Nossa equipe retornará em até 24 horas.",
    sendAnother: "Enviar outra mensagem",
    fullName: "Nome Completo",
    emailAddress: "Endereço de E-mail",
    subject: "Assunto",
    message: "Mensagem",
    sendMessage: "Enviar Mensagem",
    sending: "Enviando...",
    tellUsHelp: "Conte-nos no que podemos ajudar...",
    manageBilling: "Gerenciar Faturamento & Cancelar",
    promoCode: "CUPOM",
    freeTrialFeature: "1 Marca, 1 Plano, 20 Créditos IA, 1 Usuário",
    soloPostsFeature: "1 Marca, 3 Planos Ativos, 60 Créditos, 1 Usuário",
    growthPostsFeature: "3 Marcas, 10 Planos, 200 Créditos, 5 Usuários",
    agencyPostsFeature: "10 Marcas, 30 Planos, 500 Créditos, 20 Usuários",
    ogLocale: "pt_BR",
    aiVideoBadge: "Novo: Geração de Vídeo com IA disponível",
    trustedBy: "CONFIADO POR MARCAS INOVADORAS",
    builtForFounders: "Construído para fundadores modernos",
    commandCenterTitle: "O Centro de Comando Inteligente para sua Presença Social.",
    commandCenterDesc: "A PlataPost gera, agenda e distribui dinamicamente conteúdo consciente do contexto em todas as plataformas—impulsionado por sua identidade de marca, documentos e objetivos.",
    powerfulFeaturesKey: "Recursos Poderosos",
    aiStrategy: "Estratégia de IA",
    aiStrategyDesc: "Estratégias de conteúdo inteligentes adaptadas aos seus objetivos de marca e insights de público.",
    instantGeneration: "Geração Instantânea",
    instantGenerationDesc: "Gere legendas, posts e ideias em segundos com IA avançada.",
    brandVoiceFeature: "Voz da Marca",
    brandVoiceFeatureDesc: "Tom e mensagens consistentes impulsionados pelo seu Brand Brain e ativos.",
    step1Title: "Upload de Documentos da Marca",
    step1Desc: "Faça upload de PDFs, docs, links e ativos para construir sua base de conhecimento.",
    step2Title: "Treine seu Brand Brain",
    step2Desc: "Nossa IA aprende sua voz de marca, produtos, serviços e público.",
    step3Title: "Gere Conteúdo Semanal",
    step3Desc: "Receba um conjunto selecionado de posts, legendas e visuais adaptados aos seus objetivos.",
    step4Title: "Agende e Publique",
    step4Desc: "Revise, agende e publique em todas as suas plataformas sociais com facilidade.",
    faqCharacterTitle: "Tudo mais que você precisa saber.",
    ctaTitle: "Pronto para escalar sua marca?",
    ctaSubtitle: "Deixe a PlataPost cuidar do seu conteúdo para que você possa focar no que faz de melhor. Junte-se a centenas de marcas em crescimento hoje.",
    heroSlogan1: "VOCÊ CONSTRUIU O",
    heroSlogan2: "NEGÓCIO.",
    heroSlogan3: "NÓS CONSTRUÍMOS O",
    heroSlogan4: "CONTEÚDO.",
    selectRegion: "Selecione sua Região",
    perMonth: "/mês",
    simplePricing: "Preços Simples",
    pricingSubtitle: "Foque em criar valor, não em contar custos. Comece grátis e faça o upgrade conforme cresce.",
    promoCodeLabel: "Tem um código promocional?",
    trialDesc: "Teste a PlataPost sem riscos para construir sua estratégia.",
    soloDesc: "Ideal para marcas pessoais e empreendedores solo.",
    growthDesc: "Ideal para pequenas empresas e equipes em crescimento.",
    agencyDesc: "Poder ilimitado para agências que atendem vários clientes.",
    featuredIn: "Destaque em",
    month: "mês",
    howItWorksProcess: "O Processo",
    monthShort: "mês",
    yearShort: "ano",
    howItWorksSubtitle: "De estratégia de marca a conteúdo pronto para publicar em quatro passos simples.",
    whatBehind: "O que acontece nos bastidores:",
    examplesTitle: "Exemplos de comandos:",
    readyToTurn: "Pronto para transformar sua estratégia de marca em um calendário de conteúdo completo?",
    startWithBrain: "Comece com o Cérebro da sua Marca e deixe o PlataPost construir o plano.",
    strategyCopyCreative: "Estratégia, Redação e Criativo Juntos",
    strategyCopyCreativeDesc: "O PlataPost conecta estratégia, legendas, direção visual e agendamento de conteúdo em um único fluxo de trabalho, para que seus posts tenham consistência em todas as plataformas.",
    stayInControl: "Você Fica no Controle",
    stayInControlDesc: "A IA cuida do trabalho pesado, mas você dá a palavra final. Revise, refine, aprove, agende ou exporte sempre que estiver pronto.",
    stepLabel: "Passo",
    proprietaryAILogic: "Lógica de IA Proprietária",
    whyDifferent: "Por que o PlataPost é Diferente",
    noGenericAI: "Sem IA Genérica",
    noGenericAIDesc: "O PlataPost não depende de prompts genéricos. Cada plano de conteúdo e post é fundamentado nos detalhes da sua marca, documentos, objetivos e público.",
    multimodalStrategy: "Estratégia Multimodal",
    multimodalStrategyDesc: "Nossa IA lida com texto, conceitos visuais e direção de vídeo simultaneamente para uma coerência perfeita.",
    humanCentered: "Centrado no Humano",
    humanCenteredDesc: "Você mantém total controle criativo. A IA é sua assistente de alta velocidade, não um substituto.",
    getStartedNow: "Agendar Demo",
    plataPostFeatures: "Recursos do PlataPost",
    builtForModernGrowth: "Feito para Crescer.",
    featuresHeroSubtitle2: "Gerenciar redes sociais é um trabalho de tempo integral. Nós transformamos em um único botão.",
    aiCaptionWriting: "Escrita de Legendas com IA",
    aiCaptionWritingDesc: "Pare de olhar para uma tela em branco. Gere legendas inteligentes, ganchos atraentes e chamadas para ação que realmente convertem.",
    smartScheduling: "Agendamento Inteligente",
    smartSchedulingDesc: "Coloque seu conteúdo na fila para o momento ideal. Suporta exportação manual e publicação direta para plataformas específicas.",
    endlessContentIdeas: "Ideias de Conteúdo Infinitas",
    endlessContentIdeasDesc: "Sem ideia do que postar? Receba um mês inteiro de ideias de conteúdo baseadas em seus objetivos de negócio e produtos.",
    oneIdeaManyPlatforms: "Uma Ideia, Muitas Plataformas",
    repurposeEffortlessly: "Adapte seu conteúdo sem esforço.",
    repurposeEffortlesslyDesc: "Encontrou um ótimo post de blog ou documento interno? Alimente o PlataPost e receba uma semana de posts para o LinkedIn, carrosséis para o Instagram e scripts para o TikTok em segundos.",
    featureList: [
      "Publicação via API Direta",
      "IA com Contexto Real",
      "Geração de Conceitos Visuais"
    ],
    startBuildingCalendar: "Comece a construir seu calendário",
    canIChangePlans: "Posso mudar de plano depois?",
    canIChangePlansAns: "Com certeza. Você pode fazer o upgrade ou downgrade do seu plano a qualquer momento através das configurações do seu dashboard.",
    isThereAFreeTrialPricing: "Existe um período de teste gratuito?",
    isThereAFreeTrialPricingAns: "Você ganha 20 tokens de IA grátis ao se inscrever para tentar gerar planos, imagens e conteúdo. Você pode continuar usando a plataforma com um plano mensal ativo, mas precisará recarregar tokens ou fazer upgrade para uso contínuo da IA.",
    viewAllQuestions: "Ver todas as perguntas",
    faqHeroSubtitle: "Tudo o que você precisa saber para aproveitar ao máximo o PlataPost.",
    stillHaveQuestions: "Ainda tem dúvidas?",
    stillHaveQuestionsDesc: "Nossa equipe está aqui para ajudar você a automatizar sua estratégia de redes sociais. Entre em contato e responderemos em breve.",
    contactSupport: "Contatar Suporte",
    catGeneral: "Geral",
    catHowItWorks: "Como Funciona",
    catPricingSupport: "Preços e Suporte",
    aboutHeroTitle: "Nossa Missão.",
    aboutHeroSubtitle: "Redes sociais devem ser sobre construir conexões, não sobre combater o esgotamento.",
    aboutSectionTitle: "Consistência é a parte mais difícil.",
    aboutSectionP1: "Iniciamos o PlataPost porque vimos muitos criadores incríveis e pequenos empresários lutando para manter suas redes sociais ativas enquanto administravam seus negócios.",
    aboutSectionP2: "O problema não é a falta de ideias — é a fricção de transformar essas ideias em posts polidos, dia após dia, em cinco plataformas diferentes que exigem coisas diferentes.",
    aboutSectionP3: "O PlataPost elimina essa fricção. Nossa IA não apenas 'escreve' para você; ela atua como uma parceira estratégica que entende a voz da sua marca, lida com a formatação tediosa e permite que você foque no que faz de melhor.",
    aboutValue1: "Empoderamento",
    aboutValue2: "Authenticidade",
    aboutValue3: "Eficiência",
    aboutBuiltWithPassion: "Feito com paixão para o crescimento digital.",
    aboutNeedToReachUs: "Precisa entrar em contato? Adoraríamos ouvir você.",
    steps: {
      step1: {
        title: "Construa o Cérebro da sua Marca",
        desc: "Conte ao PlataPost sobre seu negócio, público, objetivos e tom de voz preferido. Carregue ativos da marca, documentos de estratégia, informações de produtos ou conteúdos antigos para que a IA entenda o que torna sua marca única.",
        behind: "O PlataPost transforma seus inputs em uma base de conhecimento viva da marca que guia cada recomendação de conteúdo.",
      },
      step2: {
        title: "Gere seu Calendário de Conteúdo",
        desc: "Escolha o mês, as plataformas e os objetivos da campanha. O PlataPost cria uma estratégia de conteúdo completa com ideias de posts específicos para cada plataforma, tópicos, temas e destaques para cada semana.",
        behind: "O seu Cérebro da Marca mapeia seus objetivos em um plano de conteúdo estruturado, projetado para consistência, relevância e momentum.",
      },
      step3: {
        title: "Revise e Refine",
        desc: "Revise os posts gerados por IA antes de qualquer coisa ir ao ar. Quer um tom diferente, um texto mais curto, um gancho mais forte ou outro idioma? Basta pedir ao PlataPost para refinar.",
        behind: "O PlataPost atualiza o conteúdo mantendo-se alinhado com a voz da sua marca, público e objetivos da campanha.",
        examples: ["“Deixe mais impactante.”", "“Traduza para Português.”", "“Deixe soar mais profissional.”"]
      },
      step4: {
        title: "Agende ou Exporte",
        desc: "Assim que estiver satisfeito com o conteúdo, agende as postagens para publicação automática ou exporte os textos e ativos criativos para postagem manual.",
        behind: "O PlataPost empacota seu conteúdo aprovado em um fluxo de publicação claro, quer você deseje automação total ou controle manual.",
      }
    }
  }
};

export type Language = 'en' | 'br';
